<template>
  <div class="header_flow">
    <div class="flow-title">
      <div class="title_text">
        <div class="text_name">{{info.name}}的月度绩效考核</div>
        <div class="text_time">考核时间：{{info.year}}年{{info.month}}月</div>
      </div>
    </div>
    <div class="flow-view">
      <template v-if="info.self_rating.name">
        <div 
          :class="['step','unique']">
          员工自评（{{info.self_rating.name}}）<img v-if="info.self_rating.status == 2" src="@/assets/icon2.png"></div>
        <div style="width:41px"> <img src="../../../assets/icon_jindutiao @2x.png" alt="" style="width:100%"> </div>
      </template>
      <template v-if="info.second_rating.name">
        <div :class="['step',info.enable_module == 'second_rating' || info.second_rating.status == 2 ? 'unique' : '']">
          上级评分（{{info.second_rating.name}}）<img v-if="info.second_rating.status == 2" src="@/assets/icon2.png">
        </div>
        <div style="width:41px"> <img src="../../../assets/icon_jindutiao @2x.png" alt="" style="width:100%"> </div>
      </template>
      <template v-if="info.third_rating.name">
        <div :class="['step',info.enable_module =='third_rating' || info.third_rating.status == 2 ? 'unique' : '']">
          上上级评分（{{info.third_rating.name}}）<img v-if="info.third_rating.status == 2" src="@/assets/icon2.png">
        </div>
        <div style="width:41px"> <img src="../../../assets/icon_jindutiao @2x.png" alt="" style="width:100%"> </div>
      </template>
      <div :class="['step',info.end.status == 2 ? 'unique' : '']">
        结束 <img v-if="info.end.status == 2" src="@/assets/icon2.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['info'],
}
</script>

<style scoped>
.header_flow{
  height: 183px;
background: #FFFFFF;
border-radius: 12px;
display: flex;
flex-direction: column;
}
.flow-title{
  height: 99px;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
  align-items: center;
  padding-left:22px ;
}
.flow-title .text_name{
  height: 28px;
font-size: 20px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1E2530;
line-height: 28px;
}
.flow-title .text_time{
  height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #919399;
line-height: 17px;
margin-top: 5px;
}
.flow-view{
  flex: 1;
  display: flex;
  align-items: center;
  padding-left:22px ;
}
.unique{
  background: rgba(247,126,0,0.1) !important;
}
.flow-view .step{
  width: 415px;
height: 40px;
background: #F7F8FA;
border-radius: 20px;
margin-right: 9px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #1E2530;
text-align: center;
line-height: 40px;
}
.flow-view .step img{
  width: 12px;
}
</style>